import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    BSKT_DoiTuongTuyenSinh,
    BSKT_DoiTuongTuyenSinh_ViewModel,
    CreateOrEditDoiTuongTuyenSinhDto
} from '../../services/doi-tuong-tuyen-sinh/DoiTuongTuyenSinhModels';
import { stat } from 'fs';

interface DoiTuongTuyenSinhState {
    listData: BSKT_DoiTuongTuyenSinh_ViewModel[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    selectedId: number | null;
    isShowConfirmDeleteModal: boolean;
    showCreaetOrEdit: boolean;
    createOrEditDoiTuongTuyenSinhModel: CreateOrEditDoiTuongTuyenSinhDto;
}

const initialState: DoiTuongTuyenSinhState = {
    listData: [],
    status: 'idle',
    selectedId: null,
    isShowConfirmDeleteModal: false,
    showCreaetOrEdit: false,
    createOrEditDoiTuongTuyenSinhModel: {
        ID_chuyen_nganh_tot_nghiep: 0,
        ID_chuyen_nganh_ts: 0,
        ID_doi_tuong: 0,
        ID_dot_tuyen: 0,
        ID_loai_nganh: 0,
        ListIdMonHoc: []
    }
};

const doiTuongTuyenSinhSlice = createSlice({
    name: 'doiTuongTuyenSinh',
    initialState,
    reducers: {
        setDoiTuongTuyenSinhList: (state, action: PayloadAction<BSKT_DoiTuongTuyenSinh_ViewModel[]>) => {
            state.listData = action.payload;
        },
        setDoiTuongTuyenSinhStatus: (state, action: PayloadAction<DoiTuongTuyenSinhState['status']>) => {
            state.status = action.payload;
        },
        insertDoiTuongTuyenSinhSuccess: (state, action: PayloadAction<BSKT_DoiTuongTuyenSinh_ViewModel>) => {
            state.listData.push(action.payload);
        },
        deleteDoiTuongTuyenSinhSuccess: (state, action: PayloadAction<number>) => {
            state.listData = state.listData.filter((item) => item.ID_doi_tuong !== action.payload);
            state.isShowConfirmDeleteModal = false;
        },
        setSelectedDoiTuongTuyenSinhId: (state, action: PayloadAction<number | null>) => {
            state.selectedId = action.payload;
        },
        setShowConfirmDeleteModal: (state, action: PayloadAction<{ show: boolean; id?: number }>) => {
            state.isShowConfirmDeleteModal = action.payload.show;
            state.selectedId = action.payload.id ?? null;
        },
        openCreateOrEditModal: (state, action: PayloadAction<boolean>) => {
            state.showCreaetOrEdit = action.payload;
        },
        setModelCreateOrEdit: (state, action: PayloadAction<CreateOrEditDoiTuongTuyenSinhDto>) => {
            state.createOrEditDoiTuongTuyenSinhModel = action.payload;
        },
        createOrEditDoiTuong: (state, action: PayloadAction<BSKT_DoiTuongTuyenSinh_ViewModel>) => {
            const newItem = action.payload;
            const index = state.listData.findIndex((x) => x.ID_doi_tuong === newItem.ID_doi_tuong);

            if (index !== -1) {
                // update
                state.listData[index] = newItem;
            } else {
                // insert
                state.listData.push(newItem);
            }
        },
        resetDoiTuongTuyenSinhState: () => initialState
    }
});

export const {
    setDoiTuongTuyenSinhList,
    setDoiTuongTuyenSinhStatus,
    insertDoiTuongTuyenSinhSuccess,
    deleteDoiTuongTuyenSinhSuccess,
    setSelectedDoiTuongTuyenSinhId,
    setShowConfirmDeleteModal,
    openCreateOrEditModal,
    setModelCreateOrEdit,
    createOrEditDoiTuong,
    resetDoiTuongTuyenSinhState
} = doiTuongTuyenSinhSlice.actions;

export const DoiTuongTuyenSinhReducer = doiTuongTuyenSinhSlice.reducer;
